const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '递交记录',
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '记录',
            data: [],
        },
    },
]

const dayjs = require('dayjs').default

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/track/zbggOverview`, {
                bdGuid: this.$route.query.id,
            }, { showLoading: true }).then((res) => {
                this.$request.post(`/transformToAfter/app/pre/bid/queryTbwjDiJiaoDetail`, {
                    ggBdGuid: res.data.ggBDGuid,
                }, { showLoading: true }).then((res2) => {
                    this.config[1].options.data = {
                        '标段名称': res.data.bdName,
                        '标段编号': res.data.bdBH,
                        '采购单位': res2.data.zbRName,
                        '项目经理': res2.data.projectManagerName,
                        '联系电话': res2.data.lianXiRenPhone,
                        '已递交家数': dayjs().valueOf() - res.data.kbTime < 0 ? this.getTbrs(res2.data.yiDiJiaoCount) : res2.data.yiDiJiaoCount,
                        '递交截止时间': this.$util.timeFormatter(res2.data.tbWJDiJiaoEndTime),
                    }
                })
                if (dayjs().valueOf() - res.data.kbTime >= 0) {
                    this.getQzTbrList(res.data.ggBDGuid)
                } else {
                    this.config.length = 2
                }
            })
        },
        getTbrs(num) {
            if (num >= 3) {
                return '大于等于三家'
            }
            return '小于三家'
        },
        getQzTbrList(guid) {
            return new Promise((resolve) => {
                this.$request.post(`/transformToAfter/app/pre/bid/queryTouBiaoWenJianList`, {
                    ggBdGuid: guid,
                    jieDuan: 0,
                    pageNo: 1,
                    pageSize: 9999,
                    sort: '',
                }).then((res) => {
                    if (res.data && res.data.list) {
                        this.config[3].options.data = res.data.list.filter((t) => t.isQianMing).map((t) => ({
                            '供应商名称': t.tbrName,
                            '是否确认投标': t.isQuRenTouBiao === 1 ? '是' : '否',
                            '联系人': t.touBiaoYuanName,
                            '联系电话': t.touBiaoYuanMobile,
                            '递交时间': this.$util.timeFormatter(t.qianMingTime),
                            '撤销时间': this.$util.timeFormatter(t.quXiaoQianMingTime),
                            'IP地址': t.tbrIp,
                            '递交状态': t.isQianMing ? '已递交' : '未递交',
                            'CA是否办理': t.isHandle,
                            'CA有效期（天）': t.expirationDate,
                            // '保证金递交情况': t.isPayBaoZhengJin,
                        }))
                    }
                    resolve(res)
                }).catch(() => {
                    resolve({ data: {}})
                })
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
